// extracted by mini-css-extract-plugin
export default {"card":"s0-z"};